import { render, staticRenderFns } from "./ChartRadar.vue?vue&type=template&id=2f9fa707&"
import script from "./ChartRadar.vue?vue&type=script&lang=js&"
export * from "./ChartRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports